import { createElement as _createElement } from "react";
import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import React from "react";
import SuccessBar from "../SuccessScoringGroup/SuccessBar/SuccessBar";
import useTabs from "../../Hooks/useTabs";
import useUniqueId from "../../Hooks/useUniqueId";
import CourseSectionScheduleElementInfo from "../CourseSectionScheduleElement/CourseSectionScheduleElementInfo";
import AttendanceService from "../../../Services/Attendance.service";
import TranscriptCourseAttendanceStatusService from "../../../Domain/TranscriptCourseAttendanceStatus/TranscriptCourseAttendanceStatus.service";
import useService from "../../Hooks/useService";
import ServiceResult from "../../UI/ServiceResult/ServiceResult";
import { AlertInfo } from "../../UI/StandardAlerts/StandardAlerts";
import DateService from "../../../Services/Shared/Date.service";
import AttendanceIcon from "../TranscriptCourseAttendanceStatus/Icons";
import SuccessScoringGroupService from "../../../Domain/SuccessScoringGroup/SuccessScoringGroup.service";
import Checkbox from "../../UI/Form/Checkbox";
import ClientSideTable from "../../UI/ClientSideTable/ClientSideTable";
import NewMessageModal from "../Message/NewMessageModal";
import CourseBasedSuccesScoringService from "../../../Services/CourseBasedSuccessScoring.service";
import SuccessScoringTable from "../SuccessScoring/SuccessScoringTable";
import AssignmentService from "../../../Services/Assignment.service";
import WidgetRefreshButton from "../Widgets/WidgetRefreshButton";
import usePagedSortedTable, { TotalPageMappers, } from "../../Hooks/usePagedSortedTable";
import DefaultPopover from "../../UI/Popover/DefaultPopover";
import { ItemStatusMultiSearch } from "../ItemStatus/ItemStatusSearch";
import ActivityItemTypeService from "../../../Domain/ActivityItemType/ActivityItemType.service";
import ItemStatusBadge from "../ItemStatusBadge/ItemStatusBadge";
const DetailsTab = ({ course }) => {
    const [isMessageModalOpen, setIsMessageModalOpen] = React.useState(false);
    const items = [
        {
            label: "Instructor",
            // @ts-expect-error - TS2322 - Type 'string | Element' is not assignable to type 'Node | null | undefined'.
            val: course.instructorAffiliationId ? (_jsx("button", { className: "btn btn-link p-0", onClick: () => setIsMessageModalOpen(true), children: course.instructorFullName })) : (course.instructorFullName),
        },
        {
            label: "Course Dates",
            // @ts-expect-error - TS2322 - Type 'string' is not assignable to type 'Node | null | undefined'.
            val: `${course.startDate || ""} - ${course.endDate || ""}`,
        },
        {
            label: "Course Times",
            // @ts-expect-error - TS2322 - Type 'Element[] | null' is not assignable to type 'Node | null | undefined'.
            val: course.courseSectionScheduleElements
                ? course.courseSectionScheduleElements.map((elm, index) => (_jsx(CourseSectionScheduleElementInfo, { elm: elm }, index)))
                : null,
        },
        // @ts-expect-error - TS2322 - Type 'string' is not assignable to type 'Node | null | undefined'.
        { label: "Location", val: course.locationName },
        // @ts-expect-error - TS2322 - Type 'string' is not assignable to type 'Node | null | undefined'.
        { label: "Registration Status", val: course.registrationStatus },
        // @ts-expect-error - TS2322 - Type 'string' is not assignable to type 'Node | null | undefined'.
        { label: "Registered Date", val: course.registeredDate },
        {
            label: "Current Grade",
            // @ts-expect-error - TS2322 - Type 'string | null' is not assignable to type 'Node | null | undefined'.
            val: course.currentGrade ? `${course.currentGrade}%` : null,
        },
        // @ts-expect-error - TS2322 - Type 'string | null | undefined' is not assignable to type 'Node | null | undefined'.
        { label: "Credit", val: course.credits },
        // @ts-expect-error - TS2322 - Type 'string | null | undefined' is not assignable to type 'Node | null | undefined'.
        { label: "Credits Attempted", val: course.creditAttempted },
        // @ts-expect-error - TS2322 - Type 'string' is not assignable to type 'Node | null | undefined'.
        { label: "Last Login Date", val: course.lastLoginDate },
        // @ts-expect-error - TS2322 - Type 'number' is not assignable to type 'Node | null | undefined'.
        { label: "Number of Logins", val: course.numberOfLogins },
        {
            label: "First Assignment Submitted",
            // @ts-expect-error - TS2322 - Type 'string' is not assignable to type 'Node | null | undefined'.
            val: course.firstAssignmentSubmissionDate,
        },
        {
            label: "Last Assignment Submitted",
            // @ts-expect-error - TS2322 - Type 'string' is not assignable to type 'Node | null | undefined'.
            val: course.lastAssignmentSubmissionDate,
        },
        // @ts-expect-error - TS2322 - Type 'string' is not assignable to type 'Node | null | undefined'.
        { label: "Last Attendance Date", val: course.lastAttendanceDate },
    ];
    const makeId = useUniqueId()[1];
    return (_jsxs("div", { className: "row", children: [items
                .filter((item) => item.val)
                .map((item, index) => (_jsx("div", { className: "col-lg-6", children: _jsxs("div", { className: "form-group", children: [_jsx("label", { htmlFor: makeId(index), children: item.label }), _jsx("div", { id: makeId(index), children: item.val })] }) }, index))), course.instructorAffiliationId && (_jsx(NewMessageModal, { isOpen: isMessageModalOpen, onModalClosed: () => setIsMessageModalOpen(false), recipientAffiliationIds: [course.instructorAffiliationId], size: "lg" }))] }));
};
const AttendanceTabContent = ({ attendance, }) => {
    const [showPresent, setShowPresent] = React.useState(true);
    const [showTardy, setShowTardy] = React.useState(true);
    const [showAbsent, setShowAbsent] = React.useState(true);
    const [showOthers, setShowOthers] = React.useState(true);
    const filteredAttendance = React.useMemo(() => attendance.filter((attend) => {
        const status = attend.transcriptCourseAttendanceStatus.id;
        if (!showPresent &&
            status === TranscriptCourseAttendanceStatusService.PresentId) {
            return false;
        }
        if (!showTardy &&
            status === TranscriptCourseAttendanceStatusService.TardyId) {
            return false;
        }
        if (!showAbsent &&
            status === TranscriptCourseAttendanceStatusService.AbsentId) {
            return false;
        }
        if (!showOthers &&
            ![
                TranscriptCourseAttendanceStatusService.PresentId,
                TranscriptCourseAttendanceStatusService.TardyId,
                TranscriptCourseAttendanceStatusService.AbsentId,
            ].includes(status)) {
            return false;
        }
        return true;
    }), [attendance, showAbsent, showOthers, showPresent, showTardy]);
    const checkboxes = {
        Present: {
            set: setShowPresent,
            val: showPresent,
        },
        Tardy: {
            set: setShowTardy,
            val: showTardy,
        },
        Absent: {
            set: setShowAbsent,
            val: showAbsent,
        },
        Others: {
            set: setShowOthers,
            val: showOthers,
        },
    };
    return (_jsxs("div", { children: [_jsx("div", { className: "d-flex justify-content-end", children: _jsx("div", { children: Object.keys(checkboxes).map((key) => (_jsx("div", { className: "form-check form-check-inline mr-4", children: _jsx(Checkbox, { label: key, 
                            // @ts-expect-error - TS7053 - Element implicitly has an 'any' type because expression of type 'string' can't be used to index type '{ readonly Present: { readonly set: Dispatch<SetStateAction<boolean>>; readonly val: boolean; }; readonly Tardy: { readonly set: Dispatch<SetStateAction<boolean>>; readonly val: boolean; }; readonly Absent: { ...; }; readonly Others: { ...; }; }'.
                            checked: checkboxes[key].val, 
                            // @ts-expect-error - TS7006 - Parameter 'e' implicitly has an 'any' type. | TS7053 - Element implicitly has an 'any' type because expression of type 'string' can't be used to index type '{ readonly Present: { readonly set: Dispatch<SetStateAction<boolean>>; readonly val: boolean; }; readonly Tardy: { readonly set: Dispatch<SetStateAction<boolean>>; readonly val: boolean; }; readonly Absent: { ...; }; readonly Others: { ...; }; }'.
                            onChange: (e) => checkboxes[key].set(e.target.checked) }) }, key))) }) }), filteredAttendance && filteredAttendance.length ? (_jsx(_Fragment, { children: _jsx(ClientSideTable, { striped: true, rowVerticalPadding: 2, initialSort: { columnIndex: 0, direction: "asc" }, columns: [
                        {
                            title: "Date",
                        },
                        {
                            title: "Status",
                        },
                        {
                            title: "Excused",
                            align: "center",
                        },
                        {
                            title: "Comment",
                        },
                    ], 
                    // @ts-expect-error - TS2322 - Type '(string | number)[][]' is not assignable to type 'string | number | undefined[][] | null'.
                    sortTable: filteredAttendance.map((meeting) => [
                        meeting.courseSectionMeeting.meetingStartDate.getTime(),
                        meeting.transcriptCourseAttendanceStatus.id,
                        meeting.isExcused ? 0 : 1,
                        meeting.comment || "",
                    ]), rows: filteredAttendance.map((meeting) => [
                        DateService.displayWithTime(meeting.courseSectionMeeting.meetingStartDate) +
                            " " +
                            (meeting.courseSectionMeeting.isCancelled ? "- CANCELLED" : ""),
                        _jsxs(_Fragment, { children: [_jsx(AttendanceIcon, { attendanceStatusId: meeting.transcriptCourseAttendanceStatus.id, isCancelled: meeting.courseSectionMeeting.isCancelled, addMarginRight: true }), meeting.transcriptCourseAttendanceStatus.name] }),
                        meeting.isExcused ? (_jsx("span", { className: "badge badge-success", children: "Yes" })) : (_jsx("span", { className: "badge badge-secondary", children: "No" })),
                        meeting.comment || "",
                    ]) }) })) : (_jsx(AlertInfo, { message: "No attendance records match your filter" }))] }));
};
const AttendanceTab = (props) => {
    const [courseAttendanceState, loadCourseAttendanceState] = useService(AttendanceService.getTranscriptCourseAttendance);
    React.useEffect(() => {
        loadCourseAttendanceState(props.transcriptCourseId);
    }, [loadCourseAttendanceState, props.transcriptCourseId]);
    return (_jsx(ServiceResult, { state: courseAttendanceState, errorMessage: "There was an error loading attendance for this course", children: (attendance) => attendance && attendance.length ? (_jsx(AttendanceTabContent, { attendance: attendance })) : (_jsx(AlertInfo, { message: "There is no meeting information for this course section." })) }));
};
const AssignmentsTab = (props) => {
    var _a, _b;
    const pageSize = 20;
    const showTimeout = 2000;
    const hideTimeout = 4000;
    const [isLate, setIsLate] = React.useState(false);
    const [itemStatuses, setItemStatuses] = React.useState(null);
    const sArgs = React.useMemo(() => ({ isLate, itemStatuses }), [isLate, itemStatuses]);
    const { table, refresh, dataState, isManuallyRefreshing, hasEverBeenManuallyRefreshed, } = usePagedSortedTable({
        noDataComponent: "No assignments found. Course Sections ending before the Fall 2021 term will not include assignment data.",
        striped: true,
        rowVerticalPadding: 2,
        searchArgs: sArgs,
        // @ts-expect-error - TS2322 - Type '(sort: any, pageNumber: any, searchArgs: any, isRefresh: any) => Promise<PagedResult<{ dtos: PersonLmsAssignment[]; oldestSyncDate: Date | null | undefined; }>>' is not assignable to type '(arg1: Sort | null | undefined, arg2: number, arg3: { isLate: boolean | null | undefined; itemStatuses: ItemStatus[] | null | undefined; }) => Promise<unknown>'. | TS7006 - Parameter 'sort' implicitly has an 'any' type. | TS7006 - Parameter 'pageNumber' implicitly has an 'any' type. | TS7006 - Parameter 'searchArgs' implicitly has an 'any' type. | TS7006 - Parameter 'isRefresh' implicitly has an 'any' type.
        getData: (sort, pageNumber, searchArgs, isRefresh) => {
            var _a;
            return AssignmentService.getPersonLmsAssignments({
                courseSectionLmsId: props.courseSectionLmsId,
                transcriptCourseIds: [props.transcriptCourseId],
                personLmsId: props.studentLmsId,
                isLate: searchArgs.isLate ? true : null,
                // @ts-expect-error - TS7006 - Parameter 'status' implicitly has an 'any' type.
                itemStatusIds: (_a = searchArgs.itemStatuses) === null || _a === void 0 ? void 0 : _a.map((status) => status.id),
                pullFromLms: isRefresh,
            }, {
                sort: sort === null || sort === void 0 ? void 0 : sort.sort,
                order: sort === null || sort === void 0 ? void 0 : sort.order,
                max: pageSize,
                offset: pageNumber * pageSize,
            });
        },
        initialSort: { sort: "dueDate", order: "desc" },
        getNumPages: (result) => TotalPageMappers.EngagePagedResult(result, pageSize),
        columns: [
            { title: "Name", size: 3, sortId: "name" },
            { title: "Due", size: 2, sortId: "dueDate" },
            { title: "Submitted", size: 2, sortId: "submissionDate" },
            { title: "Status", sortId: "status", align: "center" },
            { title: "Points Scored", sortId: "scoreValue", align: "end" },
            { title: "Points Possible", sortId: "pointsPossible", align: "end" },
        ],
        rows: (results) => results.data.dtos.map((assignmentData, index) => {
            var _a;
            const submissionIsLate = assignmentData.submissionDate &&
                assignmentData.dueDate &&
                assignmentData.submissionDate > assignmentData.dueDate;
            return [
                assignmentData.assignmentName,
                DateService.displayWithTime(assignmentData.dueDate),
                // eslint-disable-next-line no-nested-ternary
                assignmentData.submissionDate ? (submissionIsLate ? (_jsx(DefaultPopover, { popoverBehavior: "hover", popoverContent: "A red submission date indicates a late submission", children: (provided) => (_createElement("span", Object.assign({}, provided.popoverProps, { className: submissionIsLate ? "text-danger" : "", key: "submission-date" }), DateService.displayWithTime(
                    //  @ts-expect-error - TS2345 - Argument of type 'Date | null | undefined' is not assignable to parameter of type 'Date'. */}
                    assignmentData.submissionDate))) }, "submission-date")) : (_jsx("span", { children: DateService.displayWithTime(assignmentData.submissionDate) }, "submission-date"))) : (""),
                _jsx(ItemStatusBadge, { itemStatus: {
                        id: assignmentData.itemStatusId || 0,
                        name: assignmentData.status || "None",
                        srcStatusId: ((_a = assignmentData.itemStatusId) === null || _a === void 0 ? void 0 : _a.toString()) || "0",
                        description: assignmentData.status || "None",
                    } }, index),
                // eslint-disable-next-line no-nested-ternary
                assignmentData.scoreValue != null ? (_jsx("span", { children: assignmentData.scoreValue.toFixed(2) }, "score")) : (""),
                assignmentData.pointsPossible
                    ? parseInt(assignmentData.pointsPossible, 10).toFixed(2)
                    : "",
            ];
        }),
    });
    // @ts-expect-error - TS2571 - Object is of type 'unknown'.
    const refreshDate = (_b = (_a = dataState === null || dataState === void 0 ? void 0 : dataState.data) === null || _a === void 0 ? void 0 : _a.data) === null || _b === void 0 ? void 0 : _b.oldestSyncDate;
    let syncLabel = "";
    if (isManuallyRefreshing) {
        syncLabel = "Syncing...";
    }
    else if (refreshDate) {
        // @ts-expect-error - TS2322 - Type 'string | null' is not assignable to type 'string'.
        syncLabel = DateService.displayWithTime(refreshDate);
    }
    const [shouldShowHelp, setShouldShowHelp] = React.useState(false);
    React.useEffect(() => {
        // @ts-expect-error - TS7034 - Variable 'timeoutShow' implicitly has type 'any' in some locations where its type cannot be determined.
        let timeoutShow;
        // @ts-expect-error - TS7034 - Variable 'timeoutHide' implicitly has type 'any' in some locations where its type cannot be determined.
        let timeoutHide;
        if (dataState.isLoading) {
            timeoutShow = setTimeout(() => {
                setShouldShowHelp(true);
            }, showTimeout);
        }
        else if (shouldShowHelp) {
            timeoutHide = setTimeout(() => {
                setShouldShowHelp(false);
            }, hideTimeout);
        }
        else {
            setShouldShowHelp(false);
        }
        return () => {
            // @ts-expect-error - TS7005 - Variable 'timeoutShow' implicitly has an 'any' type.
            clearTimeout(timeoutShow);
            // @ts-expect-error - TS7005 - Variable 'timeoutHide' implicitly has an 'any' type.
            clearTimeout(timeoutHide);
        };
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [dataState.isLoading]);
    const [shouldSetFade, setShouldSetFade] = React.useState(shouldShowHelp);
    React.useLayoutEffect(() => {
        setShouldSetFade(shouldShowHelp);
    }, [shouldShowHelp]);
    return (_jsxs(_Fragment, { children: [shouldShowHelp && (_jsx(AlertInfo, { className: `fade ${shouldSetFade ? "show" : ""}`, message: "Assignment data is refreshed directly from the LMS, and is therefore dependent on the status of the LMS and current network conditions." })), _jsxs("div", { className: "d-flex justify-content-between", children: [_jsxs("div", { className: "mb-3 form-inline 3", children: [_jsx("div", { className: "form-group mr-3", children: _jsx(ItemStatusMultiSearch, { placeholder: "Status", value: itemStatuses || [], onChange: (val) => setItemStatuses(val), "aria-label": "Assignment Submission Status Search", activityItemTypeIds: [
                                        ActivityItemTypeService.LmsAssignmentSubmission,
                                    ], style: { width: 300 }, includeNoneStatus: true, disabled: dataState === null || dataState === void 0 ? void 0 : dataState.isLoading }) }), _jsx("div", { className: "form-group mr-3", children: _jsx(Checkbox, { label: "Only Late Assignments", 
                                    // @ts-expect-error - TS2322 - Type 'boolean | null | undefined' is not assignable to type 'boolean'.
                                    checked: isLate, onChange: () => {
                                        setIsLate(!isLate);
                                    }, disabled: dataState === null || dataState === void 0 ? void 0 : dataState.isLoading }) })] }), _jsxs("div", { className: "form-group d-flex justify-content-end align-items-center", children: [_jsx("small", { children: syncLabel }), _jsx(WidgetRefreshButton, { isLoading: dataState === null || dataState === void 0 ? void 0 : dataState.isLoading, onRefresh: refresh, disabled: hasEverBeenManuallyRefreshed, title: hasEverBeenManuallyRefreshed ? "Disabled" : "Refresh" })] })] }), table] }));
};
const SuccessScoreTab = (props) => {
    const [reasonsState, loadReasons] = useService(CourseBasedSuccesScoringService.getScoreReasons);
    React.useEffect(() => {
        loadReasons(props.transcriptCourseId, props.affiliationId);
    }, [loadReasons, props.affiliationId, props.transcriptCourseId]);
    return (_jsx(ServiceResult, { state: reasonsState, children: (scoring) => _jsx(SuccessScoringTable, { scoring: scoring }) }));
};
const TranscriptCourseCard = ({ course, student }) => {
    var _a;
    const [hasPermissionToViewDetails, setHasPermissionToViewDetails] = React.useState(false);
    React.useEffect(() => {
        AttendanceService.hasPermissionToViewAttendanceDetails().then(setHasPermissionToViewDetails);
    }, []);
    const [enabledState, loadEnabled] = useService(AssignmentService.enabled);
    React.useEffect(() => {
        loadEnabled();
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);
    const [tabs, tabContent, , setTab] = useTabs({
        tabs: [
            // @ts-expect-error - TS2322 - Type '{ tab: string; content: JSX.Element; }' is not assignable to type 'false'.
            {
                tab: "Details",
                content: (_jsx("div", { className: "card-body pb-0", children: _jsx(DetailsTab, { course: course }) })),
            },
            // @ts-expect-error - TS2322 - Type '{ tab: string; content: Element; } | null' is not assignable to type 'false'.
            hasPermissionToViewDetails
                ? {
                    tab: "Attendance",
                    content: (_jsx("div", { className: "card-body", children: _jsx(AttendanceTab, { transcriptCourseId: course.transcriptCourseId }) })),
                }
                : null,
            // @ts-expect-error - TS2322 - Type '{ tab: string; content: Element; id: string; } | null' is not assignable to type 'false'.
            course.successScoringGroup
                ? {
                    tab: "Success/Risk Factors",
                    content: (_jsx("div", { className: "card-body", children: _jsx(SuccessScoreTab, { transcriptCourseId: course.transcriptCourseId, affiliationId: student.affiliationId }) })),
                    id: "risk",
                }
                : null,
            // @ts-expect-error - TS2322 - Type '{ tab: string; content: Element; } | null' is not assignable to type 'false'.
            enabledState.wasSuccessful &&
                enabledState.data &&
                course.courseSectionLmsId
                ? {
                    tab: "Assignments",
                    content: (_jsx("div", { className: "card-body", children: _jsx(AssignmentsTab, { courseSectionLmsId: course.courseSectionLmsId, transcriptCourseId: course.transcriptCourseId, studentLmsId: student.lmsId }) })),
                }
                : null,
        ],
        className: "pl-3",
        tabStyle: "underline",
    });
    let borderClass = "";
    if ((_a = course.successScoringGroup) === null || _a === void 0 ? void 0 : _a.id) {
        switch (course.successScoringGroup.id) {
            case SuccessScoringGroupService.HighId.toString():
                borderClass = "card-border-top-danger";
                break;
            case SuccessScoringGroupService.MediumId.toString():
                borderClass = "card-border-top-warning";
                break;
            case SuccessScoringGroupService.LowId.toString():
                borderClass = "card-border-top-success";
                break;
            default:
                break;
        }
    }
    return (_jsxs("div", { className: "card shadow-sm " + borderClass, children: [_jsx("div", { className: "card-header bg-white border-bottom-0", children: _jsxs("div", { className: "d-flex justify-content-between", children: [_jsxs("div", { children: [_jsxs("h4", { className: "mb-0 card-title", children: [course.code, " ", course.section] }), _jsx("div", { className: "pl-1 text-muted", children: course.name })] }), course.successScoringGroup && (_jsx(_Fragment, { children: _jsx("div", { className: "text-right", children: _jsx("button", { className: "btn btn-link text-dark p-0 no-underline", style: { width: 115 }, onClick: () => setTab("risk"), children: _jsx(SuccessBar, { score: course.transcriptSuccessScore, scoringGroup: course.successScoringGroup, showLabel: true, labelOnLeft: true }) }) }) }))] }) }), tabs, _jsx("div", { className: "card-body-fixed-height", children: tabContent })] }));
};
export default TranscriptCourseCard;
